import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { Organization } from '@evc/platform';
import { AvatarComponent, Maybe } from '@evc/web-components';
import { TranslatePipe } from '@shared/services/i18n/i18n.service';

@Component({
  selector: 'adm-current-org-card',
  templateUrl: './current-org-card.component.html',
  imports: [AvatarComponent, TranslatePipe],
  styleUrls: ['./current-org-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentOrgCardComponent {
  readonly currentOrganization = input.required<Maybe<Organization>>();
}
